<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script setup>
import { useCart } from "@/app/Checkout/composables/useCart"

const { cart } = useCart()
</script>
